var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75738 6.69672C7.46449 6.40383 6.98961 6.40383 6.69672 6.69672C6.40383 6.98961 6.40383 7.46449 6.69672 7.75738L10.9394 12.0001L6.69678 16.2427C6.40388 16.5356 6.40388 17.0104 6.69678 17.3033C6.98967 17.5962 7.46454 17.5962 7.75744 17.3033L12.0001 13.0607L16.2427 17.3033C16.5356 17.5962 17.0104 17.5962 17.3033 17.3033C17.5962 17.0104 17.5962 16.5356 17.3033 16.2427L13.0607 12.0001L17.3034 7.75738C17.5963 7.46449 17.5963 6.98962 17.3034 6.69672C17.0105 6.40383 16.5356 6.40383 16.2427 6.69672L12.0001 10.9394L7.75738 6.69672Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.366a753cff5561e243d035485b9dd1bd.svg";
export { ForwardRef as ReactComponent };